import { create } from 'zustand';
import { format, startOfYear } from 'date-fns';

interface FinanceFiltersState {
  from: string;
  to: string;
  setDateRange: (from: string, to: string) => void;
  resetToYTD: () => void;
}

export const useFinanceFiltersStore = create<FinanceFiltersState>()((set) => {
  const ytdStart = format(startOfYear(new Date()), 'yyyy-MM-dd');
  const today = format(new Date(), 'yyyy-MM-dd');

  return {
    from: ytdStart,
    to: today,
    setDateRange: (from, to) => set({ from, to }),
    resetToYTD: () => set({
      from: format(startOfYear(new Date()), 'yyyy-MM-dd'),
      to: format(new Date(), 'yyyy-MM-dd'),
    }),
  };
});
